import {
  ICreateCredentialPayload,
  ICredential,
  IUpdateCredentialPayload
} from 'shared/interfaces/ctrlCredentials.interface';
import { http } from '../utils/axios';

class CtrlService {
  private static instance: CtrlService;

  static getInstance(): CtrlService {
    if (!CtrlService.instance) {
      CtrlService.instance = new CtrlService();
    }
    return CtrlService.instance;
  }

  async getCredential(): Promise<ICredential> {
    const { data } = await http<ICredential>({
      url: '/integrations/ctrl',
      method: 'GET'
    });
    return data;
  }

  async create(payload: ICreateCredentialPayload): Promise<ICredential> {
    const { data } = await http<ICredential>({
      url: '/integrations/ctrl',
      method: 'POST',
      data: payload
    });
    return data;
  }

  async update(payload: IUpdateCredentialPayload): Promise<ICredential> {
    const { data } = await http<ICredential>({
      url: '/integrations/ctrl',
      method: 'PUT',
      data: payload
    });
    return data;
  }

  async delete(): Promise<void> {
    await http<void>({
      url: '/integrations/ctrl',
      method: 'DELETE'
    });
  }
}

const instance = CtrlService.getInstance();
export default instance;
